import * as actionTypes from './actionTypes';

export const fetchAllMailingLists = () => ({
  type: actionTypes.FETCH_ALL,
});
export const fetchAllMailingListsSuccess = (ids) => ({
  type: actionTypes.FETCH_ALL_SUCCESS,
  ids,
});

export const createMailingList = (mailingList) => ({
  type: actionTypes.CREATE,
  mailingList,
});
export const createMailingListSuccess = (mailingList) => ({
  type: actionTypes.CREATE_SUCCESS,
  mailingList,
});

export const deleteMailingList = (mailingList) => ({
  type: actionTypes.DELETE,
  mailingList,
});
export const deleteMailingListSuccess = (id) => ({
  type: actionTypes.DELETE_SUCCESS,
  id,
});

export const updateMailingList = (mailingList) => ({
  type: actionTypes.UPDATE,
  mailingList,
});
export const updateMailingListSuccess = (id) => ({
  type: actionTypes.UPDATE_SUCCESS,
  id,
});

export const setActiveMailingListId = (id) => ({
  type: actionTypes.SET_ACTIVE_MAILING_LIST_ID,
  id,
});
